/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VideosAnswerFull,
    VideosAnswerFullFromJSON,
    VideosAnswerFullFromJSONTyped,
    VideosAnswerFullToJSON,
} from './';

/**
 * 
 * @export
 * @interface HomeAnswerHomeData
 */
export interface HomeAnswerHomeData {
    /**
     * 
     * @type {number}
     * @memberof HomeAnswerHomeData
     */
    streak?: number;
    /**
     * 
     * @type {VideosAnswerFull}
     * @memberof HomeAnswerHomeData
     */
    todaysVideo?: VideosAnswerFull;
    /**
     * 
     * @type {number}
     * @memberof HomeAnswerHomeData
     */
    weeklyGoal?: number;
    /**
     * 
     * @type {number}
     * @memberof HomeAnswerHomeData
     */
    programWeeklyGoal?: number;
    /**
     * 
     * @type {string}
     * @memberof HomeAnswerHomeData
     */
    videoCompletedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HomeAnswerHomeData
     */
    reassessmentRequired?: boolean;
}

export function HomeAnswerHomeDataFromJSON(json: any): HomeAnswerHomeData {
    return HomeAnswerHomeDataFromJSONTyped(json, false);
}

export function HomeAnswerHomeDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HomeAnswerHomeData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'streak': !exists(json, 'streak') ? undefined : json['streak'],
        'todaysVideo': !exists(json, 'todays-video') ? undefined : VideosAnswerFullFromJSON(json['todays-video']),
        'weeklyGoal': !exists(json, 'weekly-goal') ? undefined : json['weekly-goal'],
        'programWeeklyGoal': !exists(json, 'program-weekly-goal') ? undefined : json['program-weekly-goal'],
        'videoCompletedAt': !exists(json, 'video-completed-at') ? undefined : json['video-completed-at'],
        'reassessmentRequired': !exists(json, 'reassessment-required') ? undefined : json['reassessment-required'],
    };
}

export function HomeAnswerHomeDataToJSON(value?: HomeAnswerHomeData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'streak': value.streak,
        'todays-video': VideosAnswerFullToJSON(value.todaysVideo),
        'weekly-goal': value.weeklyGoal,
        'program-weekly-goal': value.programWeeklyGoal,
        'video-completed-at': value.videoCompletedAt,
        'reassessment-required': value.reassessmentRequired,
    };
}


